import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom'

const Portfolio = ({ match }) => {
  const [images, setImages] = useState([]);
  const {id} = useParams()

  // const URL = import.meta.env.VITE_BASE_URL;

  useEffect(() => {
    const fetchImages = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/upload/${id}`
        );

        if (!response.ok) {
          console.error('Error fetching images');
          return;
        }

        const data = await response.json();
        setImages(data);
      } catch (error) {
        console.error('Error fetching images:', error);
      }
    };

    fetchImages();
  }, [id]);


  return (
    <div>
      <h2>Images for {id} </h2>
      <div>
        {images.map((image) => (
          <div key={image._id}>
            <img src={`${URL}/${image.image}`} alt="" className="w-1/5" />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Portfolio;